// extracted by mini-css-extract-plugin
export var emailBlockLink = "_le-0";